import { render, staticRenderFns } from "./section-file-create.html?vue&type=template&id=7c82c880&scoped=true&"
import script from "./section-file-create.js?vue&type=script&lang=js&"
export * from "./section-file-create.js?vue&type=script&lang=js&"
import style0 from "./section-file-create.css?vue&type=style&index=0&id=7c82c880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c82c880",
  null
  
)

export default component.exports